/**
 * Browser download helpers.
 */

/** Filesystem-safe slug for a user-supplied name. */
export const slugify = (name, fallback = "export") => {
  const slug = String(name || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60);
  return slug || fallback;
};

/**
 * Save a JS value as a pretty-printed .json file.
 * @param {string} filename - with or without the .json suffix
 * @param {*} data
 */
export const downloadJson = (filename, data) => {
  const name = filename.endsWith(".json") ? filename : `${filename}.json`;
  const blob = new Blob([JSON.stringify(data, null, 2)], {
    type: "application/json"
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Revoke on the next tick — Safari cancels an in-flight download otherwise.
  setTimeout(() => URL.revokeObjectURL(url), 0);
};

/**
 * Read a File the user picked and parse it as JSON.
 * @param {File} file
 * @returns {Promise<*>} rejects with a readable message on bad JSON
 */
export const readJsonFile = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Could not read that file."));
    reader.onload = () => {
      try {
        resolve(JSON.parse(reader.result));
      } catch (e) {
        reject(new Error("That file isn't valid JSON."));
      }
    };
    reader.readAsText(file);
  });
